import clsx from "clsx";
import { FC } from "react";

import {
  AdornmentButton,
  AdornmentLensButton,
  FilterSearchSearchClearIcon,
  FilterSearchStyled,
} from "@ryde/controls";

import { useHeaderTopGlobalSearch } from "./hooks";

export const HeaderTopGlobalSearch: FC = () => {
  const {
    isError,
    placeholder,
    globalSearch,
    onKeyDown,
    onChangeHandler,
    searchApply,
    clearSearch,
  } = useHeaderTopGlobalSearch();
  return (
    <FilterSearchStyled
      className={clsx("header-top-global-search")}
      error={isError}
      color="secondary"
      size="small"
      placeholder={placeholder}
      value={globalSearch}
      onKeyDown={onKeyDown}
      onChange={onChangeHandler}
      startAdornment={
        <AdornmentLensButton
          position="start"
          onClick={searchApply}
          buttonProps={{
            color: isError ? "error" : "inherit",
          }}
        />
      }
      endAdornment={
        <AdornmentButton
          position="end"
          onClick={clearSearch}
          hidden={!globalSearch.length}
          buttonProps={{
            color: isError ? "error" : "inherit",
          }}
        >
          <FilterSearchSearchClearIcon />
        </AdornmentButton>
      }
    />
  );
};
